import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import { Avatar, Card, CardContent, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import theme from '../../../../theme';
import latestGpsStatus from '../../../../views/jobOrderDetail/RosterPanel/EmployeeRosterCards/latestGpsStatus';
import RosterMetaRow from '../../../../views/jobOrderDetail/RosterPanel/EmployeeRosterCards/RosterMetaRow';
import { redesignNameSx } from '../../../JobOrderCard/redesignRosterType';
import WorkerNameLink from '../../../WorkerNameLink/WorkerNameLink';

const useStyles = makeStyles({
  card: {
    cursor: 'pointer',
    boxShadow: 'none',
    '& .content': {
      display: 'flex',
      alignItems: 'center',
      padding: '0',
      justifyContent: 'space-between',
      '& .header': {
        display: 'flex',
        alignItems: 'center',
        '& .avatar': {
          marginRight: '10px',
          width: '34px',
          height: '34px',
        },
        '& .employee': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          '& .name': {
            display: 'flex',
            fontSize: '16px',
            lineHeight: '16px',
            ...theme.jobOrders.detail.roster.employeeRosterCard.employeeName,
          },
          '& .checkInStatus': {
            display: 'flex',
            fontWeight: '300',
            fontSize: '14px',
            lineHeight: '16px',
            ...theme.jobOrders.detail.roster.employeeRosterCard.checkInStatus,
          },
        },
      },
    },
  },
});

const EmployeeRosterCard = ({ placement, redesign = false }) => {
  const classes = useStyles();
  const gpsStatus = latestGpsStatus(placement);

  const CheckInStatuses = {
    PRESENT: 'present',
    SENT_HOME: 'sent-home',
    NO_SHOW: 'no-show',
  };
  const checkInStatus = placement?.timecard?.checkIn?.status;
  const checkInStatusText =
    (checkInStatus === CheckInStatuses.NO_SHOW && LanguageConverter('jobOrder.markedAsNoShow')) ||
    (checkInStatus === CheckInStatuses.SENT_HOME && LanguageConverter('jobOrder.markedAsSentHome'));

  return (
    <Card className={classes.card}>
      <CardContent className="content">
        <div className="header">
          <Avatar src={placement?.profilePic} alt={placement?.candidateName} className="avatar" />
          <div className="employee">
            <WorkerNameLink
              name={placement?.candidateName}
              userId={placement?.candidate}
              agencyId={placement?.agency}
              variant={redesign ? undefined : 'h6'}
              className={redesign ? undefined : 'name'}
              sx={redesign ? redesignNameSx : undefined}
            />
            <RosterMetaRow
              isPriorityResourcePool={placement?.isPriorityResourcePool}
              firstTimeWorkingThisCustomer={placement?.firstTimeWorkingThisCustomer}
              gpsStatus={gpsStatus}
              compactBadges
              card={redesign}
            />
            <Typography variant="body2" className="checkInStatus">
              {checkInStatusText}
            </Typography>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

EmployeeRosterCard.propTypes = {
  placement: PropTypes.shape({
    _id: PropTypes.string,
    checkInStatus: PropTypes.string,
    candidateName: PropTypes.string,
    candidate: PropTypes.string,
    agency: PropTypes.string,
    isPriorityResourcePool: PropTypes.bool,
    firstTimeWorkingThisCustomer: PropTypes.bool,
    gpsData: PropTypes.shape({
      onsite: PropTypes.bool,
      timestamp: PropTypes.number,
    }),
    gpsPings: PropTypes.arrayOf(
      PropTypes.shape({
        onsite: PropTypes.bool,
        timestamp: PropTypes.number,
      })
    ),
    timecard: PropTypes.shape({
      current: PropTypes.shape({
        punches: PropTypes.arrayOf(PropTypes.shape({})),
        totalTime: PropTypes.number,
      }),
      checkIn: PropTypes.shape({ status: PropTypes.string }),
      status: PropTypes.string,
    }),
    start: PropTypes.number,
    end: PropTypes.number,
    profilePic: PropTypes.string,
    state: PropTypes.shape({ userName: PropTypes.string }),
  }),
  redesign: PropTypes.bool,
};

export default EmployeeRosterCard;
